import { useStore } from '@/lib/store';

const sectionNames: Record<string, string> = {
  hero: 'Hero Section',
  features: 'Features',
  testimonials: 'Testimonials',
  pricing: 'Pricing',
  faq: 'FAQ',
  contact: 'Contact Form',
};

export function StepFive() {
  const { formData } = useStore();

  return (
    <div className="space-y-6 animate-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Review & Generate</h2>
        <p className="text-gray-600">Review your selections before generating your landing page.</p>
      </div>

      <div className="space-y-4">
        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-3">Business Information</h3>
          <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <dt className="text-sm text-gray-500">Business Name</dt>
              <dd className="font-medium text-gray-900">{formData.businessName || '-'}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Industry</dt>
              <dd className="font-medium text-gray-900">{formData.industry || '-'}</dd>
            </div>
            <div className="md:col-span-2">
              <dt className="text-sm text-gray-500">Description</dt>
              <dd className="font-medium text-gray-900">{formData.description || '-'}</dd>
            </div>
            {formData.targetAudience && (
              <div className="md:col-span-2">
                <dt className="text-sm text-gray-500">Target Audience</dt>
                <dd className="font-medium text-gray-900">{formData.targetAudience}</dd>
              </div>
            )}
          </dl>
        </div>

        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-3">Design</h3>
          <dl className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <dt className="text-sm text-gray-500">Style</dt>
              <dd className="font-medium text-gray-900 capitalize">{formData.style || '-'}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Primary Color</dt>
              <dd className="flex items-center space-x-2">
                <div
                  className="w-6 h-6 rounded border"
                  style={{ backgroundColor: formData.primaryColor }}
                />
                <span className="font-medium text-gray-900">{formData.primaryColor}</span>
              </dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Secondary Color</dt>
              <dd className="flex items-center space-x-2">
                <div
                  className="w-6 h-6 rounded border"
                  style={{ backgroundColor: formData.secondaryColor }}
                />
                <span className="font-medium text-gray-900">{formData.secondaryColor}</span>
              </dd>
            </div>
          </dl>
        </div>

        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-3">Content</h3>
          <div>
            <dt className="text-sm text-gray-500 mb-2">Sections</dt>
            <dd className="flex flex-wrap gap-2">
              {formData.sections?.map((section) => (
                <span
                  key={section}
                  className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium"
                >
                  {sectionNames[section] || section}
                </span>
              ))}
            </dd>
          </div>
          {(formData.customCopy?.headline || formData.customCopy?.subheadline || formData.customCopy?.ctaText) && (
            <div className="mt-4 pt-4 border-t">
              <dt className="text-sm text-gray-500 mb-2">Custom Copy</dt>
              <dd className="space-y-1 text-sm">
                {formData.customCopy?.headline && (
                  <p><span className="text-gray-500">Headline:</span> {formData.customCopy.headline}</p>
                )}
                {formData.customCopy?.subheadline && (
                  <p><span className="text-gray-500">Subheadline:</span> {formData.customCopy.subheadline}</p>
                )}
                {formData.customCopy?.ctaText && (
                  <p><span className="text-gray-500">CTA:</span> {formData.customCopy.ctaText}</p>
                )}
              </dd>
            </div>
          )}
        </div>

        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-3">Contact</h3>
          <dl>
            <div>
              <dt className="text-sm text-gray-500">Email for Leads</dt>
              <dd className="font-medium text-gray-900">{formData.contactEmail || '-'}</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-lg">Ready to generate?</h3>
            <p className="text-primary-100 mt-1">
              We'll create 3 unique variations for you to choose from.
            </p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold">Free Preview</p>
            <p className="text-primary-100 text-sm">Pay only after you choose</p>
          </div>
        </div>
      </div>
    </div>
  );
}
